export { clearApiToken, setApiToken } from "./axios"
export * from "./extractData"
export * from "./generated/McDonaldsApi"
export * from "./generated/McDonaldsInterfaces"
